import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@components/common/checkbox/main';
import AccordionSection from './accordionSection';

const CommentsFilter = ({ checked, updateFilters }) => (
  <AccordionSection title={bfTranslate("Comments")}>
    <div className="comments-section">
      <Checkbox
        size="sm"
        checked={checked}
        toggle={() => updateFilters(!checked)}
        label={bfTranslate("Only show assets with comments")}
      />
    </div>
  </AccordionSection>
);

CommentsFilter.propTypes = {
  checked: PropTypes.bool,
  updateFilters: PropTypes.func.isRequired,
};

CommentsFilter.defaultProps = {
  checked: false,
};

export default CommentsFilter;
